import { User } from "@src/interfaces";
import { request } from "@src/utils";

const listArtists = () => {
  return request.get<User[]>("/api/user/artists", {});
};

export default listArtists;
